import { render, staticRenderFns } from "./rightBottom.vue?vue&type=template&id=07c80ece&scoped=true"
import script from "./rightBottom.vue?vue&type=script&lang=js"
export * from "./rightBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c80ece",
  null
  
)

export default component.exports